/* eslint-disable  react/prop-types */

import React from 'react';

const CancelCautionIcon = () => (
  <svg
    width="68"
    height="55"
    viewBox="0 0 68 55"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="cancel-caution-icon"
  >
    <rect width="68" height="55" fill="#E5E5E5" />
    <g clipPath="url(#clip0_1099_59933)">
      <rect width="1440" height="1701" transform="translate(-709 -297)" fill="#F4F8FA" />
      <path d="M-709 -183H731V71C731 110.764 698.765 143 659 143H-709V-183Z" fill="white" />
      <g filter="url(#filter0_d_1099_59933)">
        <rect x="-316" y="21" width="654" height="80" rx="8" fill="#00AED9" />
      </g>
      <g opacity="0.6">
        <rect x="-709" y="-297" width="1440" height="1701" fill="#122946" />
      </g>
      <g filter="url(#filter1_d_1099_59933)">
        <rect x="-322" y="-99" width="706" height="464" rx="3" fill="white" />
      </g>
      <path
        d="M33.4841 36.7817H34.5295C34.8235 36.7817 35.1175 36.5203 35.1501 36.259L36.4241 27.0797V23.421C36.4241 23.0943 36.1301 22.8003 35.8035 22.8003H32.2101C31.8835 22.8003 31.5895 23.0943 31.5895 23.421V27.145L32.8635 36.259C32.8961 36.5203 33.1901 36.7817 33.4841 36.7817ZM31.3281 43.315C31.3281 44.785 32.5368 45.9937 33.9741 45.9937C35.4768 45.9937 36.6855 44.785 36.6855 43.315C36.6855 41.845 35.4768 40.6037 33.9741 40.6037C32.5368 40.6037 31.3281 41.845 31.3281 43.315Z"
        fill="#00AED9"
      />
      <path
        d="M1.7605 52.47L33.152 2.24359C33.5437 1.61693 34.4563 1.61692 34.848 2.2436L66.2395 52.47C66.6558 53.1361 66.1769 54 65.3915 54H2.6085C1.82306 54 1.34422 53.1361 1.7605 52.47Z"
        stroke="#00619E"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_1099_59933"
        x="-319"
        y="20"
        width="660"
        height="86"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="1.5" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0941176 0 0 0 0 0.207843 0 0 0 0 0.345098 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1099_59933" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1099_59933" result="shape" />
      </filter>
      <filter
        id="filter1_d_1099_59933"
        x="-325"
        y="-100"
        width="712"
        height="470"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="1.5" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0941176 0 0 0 0 0.207843 0 0 0 0 0.345098 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1099_59933" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1099_59933" result="shape" />
      </filter>
      <clipPath id="clip0_1099_59933">
        <rect width="1440" height="1701" fill="white" transform="translate(-709 -297)" />
      </clipPath>
    </defs>
  </svg>
);

export default CancelCautionIcon;
